module.exports = __webpack_public_path__ + "static/img/1.411b014.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha/1.png
// module id = 3xGH
// module chunks = 1